import React, { useState,useEffect } from 'react';
import { Modal,CircularProgress,Alert, Box, FormControl,Select, MenuItem,ListItemText,FormHelperText,Snackbar, Typography, TextField, Tooltip, Button, Checkbox, FormControlLabel, FormGroup } from '@mui/material';
import { grey, red } from '@mui/material/colors';
import AddIcon from '@mui/icons-material/Add';
import BASE_URL from '../../config'

const style = {
  position: 'absolute', 
  top: '50%', 
  left: '50%', 
  transform: 'translate(-50%, -50%)',
  bgcolor: 'white', 
  borderRadius: 4, p: 4, 
  outline: 'none',
  width: { xs: '90%', sm: '500px' },
  maxHeight: 'auto', 
  overflowY: 'auto',
  '&::-webkit-scrollbar': {
    display: 'none',
  },
  // Ocultar para Firefox
  scrollbarWidth: 'none',
  // Ocultar para Internet Explorer y Edge antiguo
  msOverflowStyle: 'none',
};

export default function Modalnewagenda({datosRango,refresh }) {
  const isSelectionIncomplete = !datosRango?.inicio || !datosRango?.horaInicio;
  
  const [agendaData, setAgendaData] = useState({ cliente: '',encargado:'',notas:'-',agentes:[],estado:'programada',prioridad:'alta'});
  const [confirmType, setConfirmType] = useState(null);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false); 
  const [error, setError] = useState(false); 
  const [showErrors, setShowErrors] = useState(false);
  const [clientesList, setClientesList] = useState([]);
  const [usuariosList, setUsuariosList] = useState([]);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

useEffect(() => {
    const fetchCatalogos = async () => {
        try {
            const res = await fetch(`${BASE_URL}/agendas/getdata`); 
            const data = await res.json();
            
            if (data.success) {
                setClientesList(data.clientes); // Guardamos solo la lista de clientes
                setUsuariosList(data.usuarios); // Guardamos solo la lista de usuarios
            }
        } catch (err) {
            console.error("Error cargando catálogos:", err);
        }
    };
    if (open) 
      setShowErrors(false);
      fetchCatalogos();
}, [open]);
  
  const resetModal = () => {
    setAgendaData({cliente: '',encargado:'',notas:'-',agentes:[],estado:'programada',prioridad:'baja' });
    setConfirmType(null);
    setError(false);
    handleClose();
  };

  const handleCheck = (nombreAgente) => {
    const { agentes } = agendaData;
    const currentIndex = agentes.indexOf(nombreAgente);
    const newAgente = [...agentes];

    if (currentIndex === -1) {
      newAgente.push(nombreAgente); 
    } else {
      newAgente.splice(currentIndex, 1); 
    }
    setAgendaData({ ...agendaData, agentes: newAgente });
  };

  const handleClose = () => {
    setOpen(false);
    setConfirmType(null);
    setLoading(false);
    setError('');
    setShowErrors(false);
    setAgendaData({ cliente: '', encargado: '', notas: '', agentes: [], estado: 'programada',prioridad:'baja' });
  };

  const handleSubmit = async () => {
    if (!agendaData.cliente || !agendaData.encargado) {
      setShowErrors(true);
      setConfirmType(null);
      return;
    }
    setLoading(true);
    setError('');

    const payload = {
      usuario_id: parseInt(agendaData.encargado, 10), 
      cliente_id: parseInt(agendaData.cliente, 10),   
      fecha_inicio: datosRango.inicio.format('YYYY-MM-DD'),
      fecha_fin: (datosRango.fin || datosRango.inicio).format('YYYY-MM-DD'),
      hora_entrada: datosRango.horaInicio.format('HH:mm'),
      hora_salida: datosRango.horaFin ? datosRango.horaFin.format('HH:mm') : null,
      estado: agendaData.estado,
      notas: agendaData.notas,
      agentesIds: agendaData.agentes.map(id => parseInt(id, 10)),
      prioridad:agendaData.prioridad,
    };

    try {
      const res = await fetch(`${BASE_URL}/agendas/newagenda`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
        const data = await res.json();
      if (res.ok) {
        setSnackbar({ open: true, message: 'Actividad agendada con éxito', severity: 'success' });
        setTimeout(() => {
          if(refresh)refresh(); 
          handleClose(); 
        }, 1500); 
      } else {
        setError(data.message || 'Error al registrar la cita.');
        setConfirmType(null); 
        setLoading(false);
      }
    } catch (e) {
      setError('Error de conexión con el servidor.');
      setConfirmType(null);
      setLoading(false);
    }
  };

    const boxstyle = { 
    mx:0.3, 
    my:0.3,  
    maxHeight: '90px',
    overflowY: 'auto', 
    bgcolor: '#ffffff',
  
    '&::-webkit-scrollbar': {
      width: '8px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: grey[300],
      borderRadius: '8px',
    },
    '&::-webkit-scrollbar-thumb:hover': {
      background: grey[500],
    },
    }

  if (confirmType) {
    return (
      <Modal open={open} onClose={() => setConfirmType(null)}>
        <Box sx={style}>
          <Box sx={{display:'flex',flexDirection:'column',gap:1}}>
            <Typography variant="h6" textAlign="start" >
              {confirmType === 'cancel' ? '¿Cancelar nuevo cliente?' : '¿Crear nuevo cliente?'}
            </Typography>
            <Typography variant="body1" color='textSecondary' >
              {confirmType === 'cancel' ? 'Los datos ingresados se perderán.¿Estás seguro que deseas cancelar?' : '¿Estás seguro que deseas crear este nuevo cliente?'}
            </Typography>
            <Box sx={{ display: 'flex', gap: 2, mt:2 , justifyContent:'end' }}>
              <Button fullWidth 
                      variant="contained" 
                      sx={{bgcolor:grey[100], color:'black',textTransform: 'none',width: { xs: '50%', sm: '38%' }}} 
                      onClick={() => setConfirmType(null)}>
                {confirmType === 'cancel' ? 'No, continuar editando' : 'No, revisar datos'}
              </Button>
              <Button fullWidth 
                      variant="contained" 
                      sx={{ bgcolor: 'black', textTransform: 'none',width: { xs: '50%', sm: '25%' } }} 
                      onClick={confirmType === 'cancel' ? resetModal : handleSubmit}>
                      
                      {loading ? <CircularProgress size={24} sx={{ color: 'white' }} /> :confirmType === 'cancel' ? 'Sí, cancelar' : 'Sí, guardar'}
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
    );
  }

  const Inputstyle = {
      '& .MuiOutlinedInput-root': {
        bgcolor: '#f5f5f5',
        borderRadius: '8px',
        '& fieldset': { borderColor: 'transparent' },
        '&:hover fieldset': { borderColor: grey[400] },
        '&.Mui-focused fieldset': { borderColor: grey[600] },
      },
    };
  

  return (
  <>
      <Button onClick={() => setOpen(true)} 
        disabled={isSelectionIncomplete}
        sx={{ borderRadius: '8px', bgcolor: 'black', textTransform:'none' }} fullWidth variant="contained" startIcon={<AddIcon />}>
        Agendar nueva cita
      </Button>
    <Modal open={open} onClose={() => setConfirmType('cancel')}>
      <Box sx={style}>
        {/* FORMULARIO */}
        <Box sx={{display:'flex',gap:2,flexDirection:'column'}}>

          {/* TITULOS */}
          <Box>
            <Typography variant="h6">Registrar Nueva Actividad</Typography>
            <Typography variant="subtitle1" color='textSecondary'>Completa la información para asginar una actividad al personal</Typography>
          </Box>

          {/* FECHAS/HORAS */}
          <Box>
            <Box>
              <Typography>Fecha</Typography>
              <Typography variant="subtitle1">
                {datosRango?.inicio?.format('DD/MM/YYYY')} 
                {datosRango?.fin && ` - ${datosRango.fin.format('DD/MM/YYYY')}`}
              </Typography>
            </Box>
            <Box>
              <Typography>Horario</Typography>
              <Typography variant="subtitle1" >
                {datosRango?.horaInicio?.format('HH:mm A')} 
                {datosRango?.horaFin ? ` a ${datosRango.horaFin.format('HH:mm A')}` : ' (Sin horario de salida)'}
              </Typography>
            </Box>
          </Box>

          {/* CLIENTES */}
          <FormControl>
            <Typography sx={{ mb: 0.5 }}>Clientes</Typography>
            <Select 
              name="cliente" 
              size='small' 
              displayEmpty 
              value={agendaData.cliente}  
              onChange={(e) => setAgendaData({ ...agendaData, cliente: e.target.value })}
              sx={Inputstyle} 
              fullWidth>
              <MenuItem disabled value="">Seleccionar Cliente</MenuItem>
              {clientesList.map((item) => (<MenuItem key={item.id} value={item.id}><ListItemText primary={item.empresa} /></MenuItem>))}
            </Select>
            { showErrors && agendaData.cliente === '' && <FormHelperText sx={{ color: red[700] }}>Campo requerido</FormHelperText>}
          </FormControl>

          {/* ENCARGADO */}
          <FormControl>
            <Typography sx={{ mb: 0.5 }}>Encargado</Typography>
            <Select 
              name="encargado" 
              size='small' 
              displayEmpty 
              value={agendaData.encargado}  
              onChange={(e) => setAgendaData({ ...agendaData, encargado: e.target.value })}
              sx={Inputstyle} 
              fullWidth>
              <MenuItem disabled value="">Seleccionar Encargado</MenuItem>
              {usuariosList.map((item) => (<MenuItem key={item.id} value={item.id}><ListItemText primary={item.nombre_completo} /></MenuItem>))}
            </Select>
            { showErrors && agendaData.encargado === '' && <FormHelperText sx={{ color: red[700] }}>Campo requerido</FormHelperText>}
          </FormControl>

          {/* AGENTES */}
          <FormGroup>
            <Typography sx={{ mb: 0.5 }}>Agentes</Typography>
            <Tooltip 
              title="Debes seleccionar al menos un agente" 
              open={error && agendaData.agentes.length === 0} 
              placement="top-end" 
              arrow
              componentsProps={{ tooltip: { sx: { bgcolor: red[700], fontWeight: 'bold' } }, arrow: { sx: { color: red[700] } } }}
            >
              <Box sx={{border: `1px solid 
                    ${error && agendaData.agentes.length === 0 ? red[700] : grey[300]}`, 
                    borderRadius: '8px'}}
              >
                <Box sx={boxstyle}>
                  {usuariosList.length > 0 ? usuariosList.map((item) => (
                    <Box
                      key={item.nombre_completo}
                      sx={{
                        ':hover': { bgcolor: grey[100] },
                        display: 'flex',
                        alignItems: 'center',
                        height: '30px',
                        transition: 'background-color 0.2s ease',
                      }}>
                      <FormControlLabel
                        control={
                          <Checkbox 
                            sx={{
                              ml: 1, 
                              color: grey[400], 
                              '&.Mui-checked': { color: 'black' } 
                            }} 
                            size="small" 
                            checked={agendaData.agentes.includes(item.id)} 
                            onChange={() => handleCheck(item.id)}
                          />
                        }
                        label={
                          <Typography variant="body2" sx={{ userSelect: 'none', fontWeight: 500 }}>
                            {item.nombre_completo}
                          </Typography>
                        }
                        sx={{ margin: 0, width: '100%' }}
                      />
                    </Box>
                  )) : (
                    <Box sx={{ p: 2, textAlign: 'center' }}>
                      <Typography variant="caption" sx={{ color: grey[500], fontStyle: 'italic' }}>
                        No hay equipos registrados.
                      </Typography>
                    </Box>
                  )}
                </Box>
              </Box>

            </Tooltip>
          </FormGroup>

                    {/* NOTAS */}
          <FormControl>
            <Typography sx={{ mb: 0.5 }}>Notas</Typography>
              <TextField  
                variant='outlined'
                fullWidth 
                name='notas'
                multiline 
                rows={2} 
                sx={Inputstyle}  
                value={agendaData.notas}
                placeholder='-'
                onChange={(e) => setAgendaData({...agendaData, notas: e.target.value})} 
                />
          </FormControl>

          {/* BOTONES */}
          <Box sx={{display:'flex',flexDirection:'row',justifyContent:'end'}}>
            <Button  
              variant="contained" 
              color='primary'
              sx={{bgcolor:grey[100], color:'black', width: { xs: '50%', sm: '25%' },textTransform: 'none',mr:1, '&:hover': {bgcolor: grey[200]}}} 
              onClick={() => setConfirmType('cancel')}>
              Cancelar
            </Button>
            <Button 
              variant="contained" 
              disabled={loading}
              onClick={handleSubmit}
              sx={{ bgcolor: 'black',ml:1, textTransform: 'none',width: { xs: '50%', sm: '30%' } }} 
            >
              {loading ? <CircularProgress size={24} sx={{ color: 'white' }} /> : "Agendar Cita"}
            </Button>
          </Box>

        </Box>
      </Box>
    </Modal>
    <Snackbar 
            open={snackbar.open} 
            autoHideDuration={1500} 
            onClose={() => setSnackbar({...snackbar, open: false})} 
            anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            
          >
            <Alert severity={snackbar.severity} variant="filled" sx={{ width: '100%', borderRadius: '10px' }}>
              {snackbar.message}
            </Alert>
    </Snackbar>
  </>
  );
}